/* eslint-disable no-undef */
import Vue from 'vue'
import VueKeyCloak from '@dsb-norge/vue-keycloak-js'
import axios from 'axios'
import Vuelidate from 'vuelidate'
import moment from 'moment'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from './plugins/store'

Vue.prototype.moment = moment
Vue.use(Vuelidate)
Vue.config.productionTip = false
const { keycloakRealm, keycloakAuthUrl, keycloakClientId } = config

function tokenInterceptor(keycloak) {
	axios.interceptors.request.use(async (config) => {
		await keycloak.updateToken(30)
		config.headers.Authorization = `Bearer ${keycloak.token}`
		return config
	}, (error) => Promise.reject(error))
}

Vue.use(VueKeyCloak, {
	config: {
		realm: keycloakRealm,
		url: keycloakAuthUrl,
		clientId: keycloakClientId,
	},
	init: {
		onLoad: 'login-required',
		checkLoginIframe: false,
	},
	onReady: (kc) => {
		tokenInterceptor(kc)
		new Vue({
			router,
			vuetify,
			store,
			created() {
				this.$vuetify.lang.current = 'en'
			},
			render: (h) => h(App),
		}).$mount('#app')
	},
})
